import classNames from 'classnames';
import Icon from '../../components/icons/Icon';
import React from 'react';
import useSheet from '../../mobile/structural/sheet/hooks/useSheet';
import { SheetId } from '../../mobile/structural/sheet/sheetTypes';
import MobileReactionsSheet from './popup/MobileReactionsSheet';

type Props = { elementId: string; gridSize: number };

const MobileElementReactionAddButton = (props: Props) => {
    const { elementId } = props;

    const sheetProps = useSheet(SheetId.ElementReactionTool, elementId);
    const { isOpen, openSheet, closeSheet } = sheetProps;

    return (
        <div className="sheet-trigger">
            <div className={classNames('add-icon', { active: isOpen })} onClick={() => openSheet()}>
                <Icon name="reaction-add" />
            </div>
            <MobileReactionsSheet {...props} sheetProps={sheetProps} closePopup={closeSheet} elementIds={[elementId]} />
        </div>
    );
};

export default MobileElementReactionAddButton;
